import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Loader } from "semantic-ui-react";

import { CustomerTeam, CustomerTeamCreateUpdateModel } from "../model";
import { UPDATE_CUSTOMER_TEAM } from "../actionTypes";
import { updateCustomerTeam } from "../actions";
import { selectors as customersSelectors } from "../../customer";
import { basePathSelector, teamSelector } from "../selectors";

import { CreateEditModal } from "./CreateEditModal";

import { push } from "redux-little-router";

interface Props {
    teams: CustomerTeam[];
}

export const Edit: React.FunctionComponent<Props> = ({ teams }) => {
    const customerId = useSelector(customersSelectors.routeIdSelector);
    const team = useSelector(teamSelector);
    const isSavingRequestName = `${UPDATE_CUSTOMER_TEAM}_${team?.id}`;
    const dispatch = useDispatch();
    const saveTeam = React.useCallback((model: CustomerTeamCreateUpdateModel) => {
        return team ? dispatch(updateCustomerTeam(customerId, team.id, model)) : Promise.resolve();
    }, [customerId, team, dispatch]);
    const basePath = useSelector(basePathSelector);
    const onClose = React.useCallback(() => dispatch(push(`${basePath}/${team?.id}`, {})), [basePath, dispatch, team?.id]);
    if (team === undefined) { return <Loader active />; }

    return (<CreateEditModal
        title="Edit Customer Team"
        onSave={saveTeam}
        isSavingRequestName={isSavingRequestName}
        defaultValues={{
            ...team,
            memberIds: team.members.map(m => m.id)
        }}
        onClose={onClose}
        teams={teams.filter(t => t.id !== team.id)}
    />);
};
